




















































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Category from "../../../store/entities/category";
import _ from "lodash";
@Component
export default class CreateCategory extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  category: Category = new Category();
  get parentCategories() {
    var list = this.$store.state.category.parentCategoriesForSelect;
    return list;
  }
  isClient() {
    return !_.isNil(this.$store.state.session.client);
  }
  get client() {
    return this.$store.state.session.client;
  }
  save() {
    if (this.isClient()) this.category.clientCode = this.client.code;
    (this.$refs.createCategoryForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store
          .dispatch({
            type: "category/create",
            data: this.category,
          })
          .then(async () => {
            await this.$store.dispatch({
              type: "category/getParentListForSelect",
              data: {
                isMaster: !this.isClient(),
              },
            });
            Util.showSuccessMsg(this, "Success.CreateCategorySucc");
            (this.$refs.createCategoryForm as any).resetFields();
            this.$emit("save-success");
            this.$emit("input", false);
          });
      }
    });
  }
  cancel() {
    (this.$refs.createCategoryForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  validateCode = (rule: any, value: any, callback: any) => {
    if (!value) {
      callback(new Error(this.L("Error.CodeRequired")));
    } else if (Util.hasUnicode(value)) {
      callback(new Error(this.L("Error.CodeCanNotContainUnicode")));
    } else {
      callback();
    }
  };
  categoryRule = {
    code: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Code")),
        trigger: "blur",
      },
      { validator: this.validateCode, trigger: "blur" },
    ],
    name: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Name")),
        trigger: "blur",
      },
    ],
  };
}
